<template>
  <div style="border: 1px solid red;">
    <div v-if="mode === 'DESIGN'">

    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <div v-for="item, index in detailList">
        <div style="background-color: gainsboro;width: 100%;">
          <span style="margin-left: 10px;">
            {{item.name}}
          </span>
          <span style="margin-left: 25px;">说明：{{item.description}}</span><br/>
          <span v-for="i, e in JSON.parse(item.template)" style="margin-left: 10px;">
            <span v-if="e == 0">模板：</span>
            <el-button style="margin: 0 15px;" type="text" @click="downLoadTemplate(i)">{{ i.name }}</el-button>
            <span v-if="e < JSON.parse(item.template).length - 1"> | </span>
          </span>
        </div>
        <div>
          <el-upload v-show="!readonly" ref="upload" :action="upload.url + '?updateSupport=' + upload.updateSupport"
            :disabled="upload.isUploading" :headers="upload.headers" :on-progress="handleFileUploadProgress" multiple
            :on-success="(response, file, fileList) => handleFileSuccess(response, file, fileList, item)"
            :on-remove="(file, fileList) => handleFileRemove(file, fileList, item)">
            <el-button size="small" icon="el-icon-paperclip" round>选择文件</el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <div v-for="item, index in detailList">
        <div>
          {{item.name}}
          <span style="margin-left: 25px;">说明：{{item.description}}</span><br/>
          <span v-for="i, e in JSON.parse(item.template)">
            <el-button style="margin: 0 15px;" type="text" @click="downLoadTemplate(i)">{{ i.name }}</el-button>
            <span v-if="e < JSON.parse(item.template).length - 1"> | </span>
          </span>
        </div>
        <div>
          <el-upload v-show="!readonly" ref="upload" :action="upload.url + '?updateSupport=' + upload.updateSupport"
            :disabled="upload.isUploading" :headers="upload.headers" :on-progress="handleFileUploadProgress" multiple
            :on-success="(response, file, fileList) => handleFileSuccess(response, file, fileList, item)"
            :on-remove="(file, fileList) => handleFileRemove(file, fileList, item)">
            <el-button size="small" icon="el-icon-paperclip" round>选择文件</el-button>
          </el-upload>
        </div>
      </div>
      <!-- <radio-group v-model="_value" direction="horizontal">
        <radio style="margin: 5px" v-for="(op, index) in options" :key="index" :name="op">{{ op }}</radio>
      </radio-group> -->
    </div>
    <div v-else>
      <div v-for="item, index in fileMap">
        <div>
          {{item[0].name}}
          <span style="margin-left: 25px;">说明：{{item[0].description}}</span><br/>
          <span v-for="i, e in JSON.parse(detailList.find(d => d.id == item[0].id).template)">
            <el-button style="margin: 0 15px;" type="text" @click="downLoadTemplate(i)">{{ i.name }}</el-button><br/>
          </span>
        </div>
        <div>
          <el-upload v-show="!readonly" ref="upload" :action="upload.url + '?updateSupport=' + upload.updateSupport"
            :disabled="upload.isUploading" :headers="upload.headers" :on-progress="handleFileUploadProgress" multiple
            :on-success="(response, file, fileList) => handleFileSuccess(response, file, fileList, item)"
            :on-remove="(file, fileList) => handleFileRemove(file, fileList, item)">
            <el-button size="small" icon="el-icon-paperclip" round disabled>选择文件</el-button>
          </el-upload>
        </div>
        <div>
          <div v-if="item.length == 1 && item[0].url">
            <el-button type="text" @click="handleDownLoad(item[0].url)">{{ item[0].urlName }}</el-button>
          </div>
          <div v-else-if="item.length > 1">
            <div v-for="i in item">
              <el-button v-if="i.url" type="text" @click="handleDownLoad(i.url)">{{ i.urlName }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Popup, Picker, Radio, RadioGroup } from 'vant';
import componentMinxins from '../ComponentMinxins'
import { getReportDetailsByTenant } from '@/api/ops/report';

export default {
  mixins: [componentMinxins],
  name: "ReportTypeInput",
  components: { Radio, RadioGroup, Picker, Field, Popup },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '请选择选项'
    },
    expanding: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    propValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    tenant: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showPicker: false,
      templateList: [],
      detailList: [],
      fileMap: {},
      // 模板导入参数
      upload: {
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的权限数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: {
          Authorization: "Bearer " + localStorage.getItem("wflow-token"),
        },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/system/report/importData"
      },
    }
  },
  created() {
    const selectedIds = Array.isArray(this.propValue.report) ? this.propValue.report : [];
    // 假设 formData 已经包含历史上传数据
    if (this.value && typeof this.value === 'string') {
      try {
        this.fileMap = JSON.parse(this.value);
        for (let i = 0; i < selectedIds.length; i++) {
          getReportDetailsByTenant(this.tenant, selectedIds[i]).then(res => {
            this.detailList.push(...res.data)
          })
        }
      } catch (e) {
        console.warn('解析历史数据失败');
      }
    } else {
      this.templateList = this.options.filter(item => selectedIds.includes(item.id));
      for (let i = 0; i < selectedIds.length; i++) {
        getReportDetailsByTenant(this.tenant, selectedIds[i]).then(res => {
          this.detailList.push(...res.data)
          for (let j = 0; j < res.data.length; j++) {
            this.fileMap[res.data[j].id] = [{
              id: res.data[j].id,
              name: res.data[j].name,
              description: res.data[j].description
            }]
          }
        })
      }
    }
    setTimeout(() => {
      this.$forceUpdate()
    }, 300)
  },
  methods: {
    onConfirm(val) {
      this.showPicker = false
      this._value = val
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList, item) {
      this.upload.isUploading = false;
      if (response && response.url) {
        // 将上传成功的 URL 按照 item.id 存入 fileMap
        // 判断当前this.fileMap中是否已经存在item.id对应的值，如果存在则追加，不存在则添加
        const fileId = item.id;
        // 判断当前 this.fileMap 中是否已存在该 id
        if (!this.fileMap[fileId]) {
          // 不存在，则初始化为数组并添加第一个元素
          this.fileMap[fileId] = [{
            id: fileId,
            name: item.name,
            description: item.description,
            urlName: response.name,
            url: response.url
          }];
        } else {
          // 文件是否重复是用户的操作，不做判断，直接保存
          this.fileMap[fileId].push({
            id: fileId,
            name: item.name,
            description: item.description,
            urlName: response.name,
            url: response.url
          });
        }
        // 同步更新 this._value
        this._value = JSON.stringify(this.fileMap);
      }
    },
    handleFileRemove(file, fileList, item) {
      // 如果有 response.url，则从 fileMap 中删除
      if (file.response?.url) {
        // 如果this.fileMap[item.id]中只有一个值则删除，如果有多个值，删除file.response.url与this.fileMap[item.id][i].url相同的值
        if (this.fileMap[item.id].length === 1) {
          this.fileMap[item.id] = [{
            id: item.id,
            name: item.name,
            description: item.description
          }];
        } else {
          for (let i = 0; i < this.fileMap[item.id].length; i++) {
            if (this.fileMap[item.id][i].url === file.response.url) {
              this.fileMap[item.id].splice(i, 1);
            }
          }
        }
        this._value = JSON.stringify(this.fileMap);
      }
    },
    handleDownLoad(url) {
      window.open(url)
    },
    downLoadTemplate(template) {
      const link = document.createElement('a');
      link.href = template.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style scoped></style>
